import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const checkedInputDefaultVariants = {}
const checkedInputCompoundVariants = []

const checkedInputSlotNames = [
  [
    "control",
    "input__control"
  ],
  [
    "input",
    "input__input"
  ],
  [
    "action_wrapper",
    "input__action_wrapper"
  ],
  [
    "checkbox",
    "input__checkbox"
  ],
  [
    "radio",
    "input__radio"
  ],
  [
    "label",
    "input__label"
  ]
]
const checkedInputSlotFns = /* @__PURE__ */ checkedInputSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, checkedInputDefaultVariants, getSlotCompoundVariant(checkedInputCompoundVariants, slotName))])

const checkedInputFn = memo((props = {}) => {
  return Object.fromEntries(checkedInputSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const checkedInputVariantKeys = []
const getVariantProps = (variants) => ({ ...checkedInputDefaultVariants, ...compact(variants) })

export const checkedInput = /* @__PURE__ */ Object.assign(checkedInputFn, {
  __recipe__: false,
  __name__: 'checkedInput',
  raw: (props) => props,
  variantKeys: checkedInputVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, checkedInputVariantKeys)
  },
  getVariantProps
})